'use strict'

import angular from 'angular'

import buySheetSimpleFieldsListComponentHtmlUrl from './buySheetSimpleFieldsList.component.html'

angular.module('buySheet.components').component('buySheetSimpleFieldsList', {
    templateUrl: buySheetSimpleFieldsListComponentHtmlUrl,
    bindings: {
        entity: '<'
    },
    controllerAs: 'vm'
})